<template>
  <layout>
    <template v-slot:header>
      <div class="admin-header-container align-items-start align-items-lg-center mb-2 mb-lg-0">
        <h2 class="m-0">Footer Messages</h2>
        <jet-button class="btn-short ml-0 ml-lg-2" :goesTo="route('footer_messages.create')" icon="fas fa-plus">Create Footer Message</jet-button>
      </div>
      <BreadCrumbs activeItem="Footer Messages" :crumbs="{ home: 'Dashboard'}"/>
      <flash-messages />
      <AppHead title="Manage Footer Messages" />
    </template>

    <template v-slot:default>
      <div class="row mb-4">
        <div class="col-12 col-lg-12 table-responsive">
          <table class="table table-striped table-sm tbody-border">
            <thead>
            <tr>
              <th>Message</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="footer_message in footer_messages" :key="footer_message.id">
              <td>
                <inertia-link class="px-6 py-4 m-text-nowrap flex items-center focus:text-indigo-500" :href="editMessage(footer_message.id)">
                  {{ footer_message.message }}
                </inertia-link>
              </td>
              <td class="d-flex justify-content-end pr-5">
                <jet-button class="btn-short mr-2 text-nowrap" :goesTo="route('footer_messages.edit', footer_message.id)" icon="fas fa-pencil-alt">Edit</jet-button>
                <jet-button class="btn-short text-nowrap" btnStyle="danger" @click="$inertia.visit(route('footer_messages.destroy', footer_message.id))" icon="nav-icon fas fa-trash">Remove</jet-button>
              </td>
            </tr>
            </tbody>
            <tr v-if="footer_messages.length === 0">
              <td class="border-t px-6 py-4" colspan="4">No footer messages.</td>
            </tr>
          </table>
        </div>
      </div>
    </template>
  </layout>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import SearchFilter from '@/Shared/SearchFilter'
import FlashMessages from '@/Shared/FlashMessages'
import BreadCrumbs from '@/Shared/BreadCrumbs'

export default {
  components: {
    Icon,
    SearchFilter,
    Layout,
    FlashMessages,
    BreadCrumbs
  },
  props: {
    footer_messages: Array,
    filters: Object,
  },
  data() {
    return {
      
    }
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    editMessage(footerMessageId) {
      return this.route('footer_messages.edit', footerMessageId);
    }
  },
}
</script>
